import { Route } from "@angular/router";
import { DavParamEditComponent } from "./dav-param-edit.component";
import { DavResolver } from "../shared/resolver/dav-resolver";

export const DavParamEditRouting: Route = {
    path: ':dav',
    component: DavParamEditComponent,
    resolve:{
        dav: DavResolver
    },
    data: {
        breadcrumb: ":dav.nom"
    }
}
